import { fromConsignmentItemDetailsResponseV3, toPatchConsignmentItemRequest } from '../models/mapper'
import { ConsignmentItemPatch } from '../models/request'
import { ConsignmentItemDetails } from '../models/types'
import { patchConsignmentItemV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function patchConsignmentItem(id: number, patch: ConsignmentItemPatch): Promise<ConsignmentItemDetails> {
  const response = await patchConsignmentItemV3(id, toPatchConsignmentItemRequest(patch))
  return fromConsignmentItemDetailsResponseV3(response)
}
